import { render, staticRenderFns } from "./set-trader.vue?vue&type=template&id=63892b35&scoped=true"
import script from "./set-trader.vue?vue&type=script&lang=js"
export * from "./set-trader.vue?vue&type=script&lang=js"
import style0 from "./set-trader.vue?vue&type=style&index=0&id=63892b35&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63892b35",
  null
  
)

export default component.exports